// X KLUSIVE – keeps the WhatsApp button and restock alert in sync with the selected option.
(function () {
  const IDS = ['XkWhatsapp', 'XkRestock'];

  function sync(sectionId, html) {
    IDS.forEach((id) => {
      const source = html.getElementById(`${id}-${sectionId}`);
      const destination = document.getElementById(`${id}-${sectionId}`);
      if (!source || !destination) return;
      destination.innerHTML = source.innerHTML;
      destination.classList.toggle('hidden', source.classList.contains('hidden'));
    });
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const data = event && event.data;
      if (data && data.html) sync(data.sectionId, data.html);
    });
  }

  // After a successful sign-up the page reloads; make sure the confirmation is visible
  // even if the page came back on an in-stock option.
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.xk-restock').forEach((box) => {
      const success = box.querySelector('[data-xk-restock-success]');
      if (success && window.location.hash === `#${box.dataset.formId}`) {
        box.classList.remove('hidden');
        success.focus();
      }
    });
  });
})();
